//! Login
export const API_LOGIN = '/as/api/plg/v1/seller/login'
export const API_LOGOUT = '/as/api/plg/v1/seller/logout'
export const API_REFRESH_TOKEN = '/as/api/plg/v1/seller/refresh-token'
